export const getLocalStorageItem = (key) => {
  return JSON.parse(localStorage.getItem(key) || null);
};
